export enum TypeForOrderTypes {
  salesOrder = 'SALES',
  purchaseOrder = 'PURCHASE',
  salesInvoice = 'SALES INVOICE',
  purchaseInvoice = 'PURCHASE INVOICE',
  debitNote = 'DEBIT NOTE',
  creditNote = 'CREDIT NOTE',
}
